__turbopack_context__.v({
  "close": "broadcastNotification-module-scss-module__fj-K2G__close",
  "entities": "broadcastNotification-module-scss-module__fj-K2G__entities",
  "entity": "broadcastNotification-module-scss-module__fj-K2G__entity",
  "notificationPopup": "broadcastNotification-module-scss-module__fj-K2G__notificationPopup",
  "title": "broadcastNotification-module-scss-module__fj-K2G__title",
});
